import { useState } from "react";
import { Loader2 } from "lucide-react";

// Reutilizado en /admin/cuenta y /portal/cuenta: recibe la instancia de axios (adminApi o
// portalApi) y el conjunto de testIds propio de cada superficie.
export function ChangePasswordForm({ api, testIds, tokenStorageKey, onSuccess }) {
  const [actual, setActual] = useState("");
  const [nueva, setNueva] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [error, setError] = useState("");
  const [exito, setExito] = useState(false);
  const [cargando, setCargando] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setExito(false);
    if (nueva.length < 6) {
      setError("La nueva contraseña debe tener al menos 6 caracteres");
      return;
    }
    if (nueva !== confirmar) {
      setError("Las contraseñas nuevas no coinciden");
      return;
    }
    setCargando(true);
    try {
      const { data } = await api.post("/auth/change-password", { password_actual: actual, password_nueva: nueva });
      if (data.token && tokenStorageKey) localStorage.setItem(tokenStorageKey, data.token);
      setExito(true);
      setActual("");
      setNueva("");
      setConfirmar("");
      onSuccess?.();
    } catch (err) {
      setError(err?.response?.data?.detail || "No se pudo cambiar la contraseña");
    } finally {
      setCargando(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="flex max-w-sm flex-col gap-4">
      <div>
        <label className="mb-1.5 block text-sm font-medium text-[var(--tc-text)]">Contraseña actual</label>
        <input
          data-testid={testIds.currentInput}
          type="password"
          required
          value={actual}
          onChange={(e) => setActual(e.target.value)}
          className="w-full rounded-[var(--tc-radius)] border border-[var(--tc-border)] px-3.5 py-2.5 text-sm outline-none focus:border-[var(--tc-accent)] focus:ring-2 focus:ring-[var(--tc-accent-soft)]"
        />
      </div>
      <div>
        <label className="mb-1.5 block text-sm font-medium text-[var(--tc-text)]">Nueva contraseña</label>
        <input
          data-testid={testIds.newInput}
          type="password"
          required
          value={nueva}
          onChange={(e) => setNueva(e.target.value)}
          className="w-full rounded-[var(--tc-radius)] border border-[var(--tc-border)] px-3.5 py-2.5 text-sm outline-none focus:border-[var(--tc-accent)] focus:ring-2 focus:ring-[var(--tc-accent-soft)]"
        />
      </div>
      <div>
        <label className="mb-1.5 block text-sm font-medium text-[var(--tc-text)]">Confirmar nueva contraseña</label>
        <input
          data-testid={testIds.confirmInput}
          type="password"
          required
          value={confirmar}
          onChange={(e) => setConfirmar(e.target.value)}
          className="w-full rounded-[var(--tc-radius)] border border-[var(--tc-border)] px-3.5 py-2.5 text-sm outline-none focus:border-[var(--tc-accent)] focus:ring-2 focus:ring-[var(--tc-accent-soft)]"
        />
      </div>
      {error && (
        <p data-testid={testIds.error} className="rounded-[var(--tc-radius)] bg-red-50 px-3 py-2 text-sm text-red-600">
          {error}
        </p>
      )}
      {exito && (
        <p data-testid={testIds.success} className="rounded-[var(--tc-radius)] bg-green-50 px-3 py-2 text-sm text-green-700">
          Contraseña actualizada. Cerramos tus otras sesiones activas.
        </p>
      )}
      <button
        data-testid={testIds.submitButton}
        type="submit"
        disabled={cargando}
        className="mt-1 inline-flex items-center justify-center gap-2 rounded-[var(--tc-radius)] bg-[var(--tc-accent)] px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[var(--tc-accent-hover)] disabled:cursor-not-allowed disabled:opacity-60"
      >
        {cargando ? <Loader2 size={16} className="animate-spin" /> : null} Cambiar contraseña
      </button>
    </form>
  );
}
